import { defineComponent as _defineComponent } from 'vue'
import moment from 'moment';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n-composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

const display = ref(false);
const i18n = useI18n();
/**
   * Display full release name and publish date
   * Format is always prefixed with "release_date" and can have additional data after that
   * If LastRelease, don't display the rest of the string
   */
const version = computed(() => {
  const currentVersion = config.VUE_APP_VERSION || process.env.VUE_APP_VERSION;
  let displayedRelease = '';
  if (currentVersion) {
    const release = currentVersion.split('_');
    if (release[0] === 'LastRelease') {
      displayedRelease = `LastRelease - (${moment(release[1], 'YYYYMMDDHHmmss').format('D MMM YYYY HH:mm:ss')})`;
    } else {
      displayedRelease = `${currentVersion} - (${moment(release[1], 'YYYYMMDDHHmmss').format('D MMM YYYY HH:mm:ss')})`;
    }
  }
  return displayedRelease;
});

const userGuide = computed(() => '/documents/Tolling_Proxy_User_Guide_R515.pdf');


return { __sfc: true,display, i18n, version, userGuide }
}

})